const staticContent = [
  { label: 'Keine Angaben', value: 101 },
  { label: 'Vollzeit', value: 100 },
  { label: '< 100%', value: 99 },
  { label: '< 80%', value: 80 },
  { label: '< 50%', value: 50 }
];
module.exports = staticContent;
